import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

export interface AuthConfigResponse {
  enableMicrosoftLogin: boolean;
  disableLegacyLogin: boolean;
  tenantId: string;
  clientId: string;
  apiClientId: string;
  scopes: string[];
}

const defaultConfig: AuthConfigResponse = {
  enableMicrosoftLogin: false,
  disableLegacyLogin: false,
  tenantId: '',
  clientId: '',
  apiClientId: '',
  scopes: [],
};

@Injectable({ providedIn: 'root' })
export class AuthConfigService {
  private _config$ = new BehaviorSubject<AuthConfigResponse | null>(null);

  constructor(private http: HttpClient) {}

  // Fetches Microsoft login configuration before any auth logic runs.
  async load(): Promise<void> {
    try {
      const config = await firstValueFrom(
        this.http.get<AuthConfigResponse>('/api/auth/microsoft/config')
      );
      this._config$.next({ ...defaultConfig, ...config });
    } catch (err) {
      this._config$.next(defaultConfig);
    }
  }

  get config$() {
    return this._config$.asObservable();
  }

  get config(): AuthConfigResponse {
    return this._config$.getValue() ?? defaultConfig;
  }
}
